// Lib
import { prop } from '../../../../../../common/utils/immutableHelper';

// Accessor methods
export const getGroupType = prop('groupType');
export const getGroupId = prop('id');
export const getGroupTimestamp = prop('timestamp');
export const getGroupTitle = prop('title');
export const getGroupChangeCount = prop('changeCount');
export const getGroupNotifications = (group) => prop('notifications', group) || [];
export const getGroupNotificationsToDisplay = (group) =>
    prop('notificationsToDisplay', group) || getGroupNotifications(group);
export const getGroupUnseen = prop('unseen');
